import React, { Component } from 'react'
import { Row, Col, Container } from 'reactstrap'
import Card from '../Cards/Card'
import * as actionCreators from '../../Actions/Index';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Cookies from 'universal-cookie';
//import { Helmet } from 'react-helmet'
import SpinnerPage from '../Loader/SpinnerPage';
import $ from 'jquery'

var cookie = new Cookies();

class Brand extends Component {

    constructor(props) {

        super(props);
        this.state = {
            HOLA: [
                { id: 1, title: 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/DSC_2484_-_Copy.JPG?v=1553906693", price: "1290", saveCount: 82 },
                { id: 2, title: 'Khaadi', image: "https://www.khaadi.com/media/catalog/product/cache/8311afee373c39545ab7d755459cdad7/w/t/wtpe19208b_ltblue_1_.jpg", price: "1290", saveCount: 80 },
                { id: 3, title: 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0707-SSH-BLU_1.jpg?v=1552043754", price: "1290", saveCount: 82 },
                { id: 4, title: 'Limelight', image: "https://d224nth7ac0evy.cloudfront.net/catalog/product/cache/926507dc7f93631a094422215b778fe0/i/p/ipw-18-62-_3_.jpg", price: "1290", saveCount: 82 },
                { id: 5, title: 'Limelight', image: "https://www.junaidjamshed.com/media/catalog/product/cache/image/e9c3970ab036de70892d86c6d221abfe/j/j/jjpw-a-jps-203-1.jpg", price: "1290", saveCount: 82 },
                { id: 6, title: 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0387-SSH-PNK_1.jpg?v=1551876015", price: "1290", saveCount: 82 },
            ],
            brandsProduct: [],
            cat: {},
            error: [],
            showItems: 20,
            isloder: true
        }
    }
    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight + 200;
    }
    componentWillMount() {

        var brandName = this.props.match.params.brand;
        // var brandP = {
        //   "brandName": brandName,
        //   "UserID": cookie.get("usfid"),
        //   "isImport": false
        // }


        document.addEventListener('scroll', this.trackScrolling);
        //   this.unlisten = this.props.history.listen((location, action) => {
        //       this.props.getProductByBrandName(brandP);

        //   this.setState({brandsProduct:this.props.brandsProduct});
        //   });
        //  this.props.getProductByBrandName(brandP);
        //   this.setState({brandsProduct:this.props.brandsProduct});

        // var morph_api_url = 'https://api.morph.io/SelectSoft/select_jigar/data.json';
        // var morph_api_params = {
        //     // Keep this key secret!
        //     key: '7hDDGSosf23K7474Bd4P',
        //     query: `Select product.ProductCount ,product.ProductID ,product.Price, product.Brand_Name ,images.ImageURL from product,images where product.SKU = Images.SKU and images.display = 1 and brand_name like '${brandName}' order by RANDOM()`
        // };

        // let _this = this;
        // $.ajax({
        //     url: morph_api_url + '?' + $.param(morph_api_params),
        //     dataType: 'jsonp',
        //     success: function (data) {
        //         let res = JSON.parse(JSON.stringify(data));
        //         _this.setState({ brandsProduct: res });
        //         _this.setState({ isloder: false });
        //     }
        // });

    }
    componentWillUnmount() {
        document.removeEventListener('scroll', this.trackScrolling);
    }

    componentWillReceiveProps(nextProps) {
        var joined = this.state.brandsProduct.concat(nextProps.brandsProduct);
        this.setState({ brandsProduct: nextProps.brandsProduct });
    }
    trackScrolling = () => {
        const wrappedElement = document.getElementById('root');
        if (this.isBottom(wrappedElement)) {

            this.handleShowMore();
        }
    };
    handleShowMore() {
        this.setState({
            showItems: this.state.showItems >= this.state.brandsProduct?.length ?
                this.state.showItems : this.state.showItems + 20
        })
    }

    render() {
        return (
            <div>
                <Container className="productContainer" >
                    {this.state.isloder ?
                        <div style={{ marginLeft: "42%", marginTop: "32%" }} >
                            <SpinnerPage />
                        </div>
                        : null}
                    <ol className="product-items" >
                        {this.state.brandsProduct.slice(0, this.state.showItems).map(item => {
                            return (
                                <Card flag={item.flag == "true" ? 1 : 0}
                                    id={item.ProductID}
                                    title={item.Brand_Name}
                                    image={item.ImageURL}
                                    price={item.Price}
                                    saveCount={item.ProductCount} > </Card>

                            )
                        })
                        }
                    </ol>
                </Container>
            </div>
        )
    }


}
const mapStateToProps = (state) => (

    {
        brandsProduct: state.brandsProduct,
        cat: state.cat,
    });

const mapDispatchToProps = dispatch => {
    return {
        getProductByBrandName: (brandP) => dispatch(actionCreators.getProductByBrandName(brandP)),
    }

}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Brand))